import NumberFormat from "react-number-format";

class CustomNumberFormat extends NumberFormat {
  onChange(k, v) {
    //let inputValue = v
    const { state, props } = this;
    const { isAllowed } = props;
    //const lastValue = state.value || ''
    const lastValue = state.value;
    let { formattedValue, value } = this.formatInput(v);

    //let formattedValue = this.formatInput(inputValue) || ''
    //let numAsString = this.removeFormatting(formattedValue)

    /*const valueObj = {
      formattedValue,
      value: numAsString,
      floatValue: parseFloat(numAsString)
    }*/

    //if (!isAllowed(valueObj)) {
    if (!isAllowed(formattedValue, value, this.getFloatValue(value))) {
      formattedValue = lastValue;
    }

    /*if (isNaN(valueObj.floatValue)) {
      valueObj.formattedValue = '$0'
      valueObj.floatValue = 0
    }*/

    //numAsString = '' + valueObj.floatValue
    //valueObj.value = numAsString

    if (formattedValue !== lastValue || v !== lastValue) {
      this.setState(
        {
          value: formattedValue /*,
        numAsString*/
        },
        () => {
          props.onChange(null, value);
          //props.onValueChange(valueObj)
          //props.onChange(null, valueObj.floatValue, v)
        }
      );
    } /* else {
      props.onChange(null, valueObj.floatValue, v)
    }*/
  }
}

export default CustomNumberFormat;



// WEBPACK FOOTER //
// ./src/components/ui-building-blocks/numbers/CustomNumberFormat.js